export default __webpack_public_path__ + "static/media/10.5b8dbc3a.jpg";